module.exports = __webpack_public_path__ + "img/footer.7aca45ec.png";